import { Slider } from '../../components/Slider';
import { useEditorStore } from '../../store/editorStore';

// Crop, straighten, flips and 90° rotation. (Interactive crop-handle dragging
// on the canvas is a later enhancement; these controls cover framing today.)
export function CropPanel() {
  const state = useEditorStore((s) => s.state);
  const set = useEditorStore((s) => s.set);
  const update = useEditorStore((s) => s.update);

  return (
    <>
      <Slider
        label="Straighten"
        help="crop"
        value={state.crop.angle}
        min={-45}
        max={45}
        step={0.1}
        onChange={(v) => update((d) => (d.crop.angle = v))}
      />

      <div className="rowbtns">
        <button
          className="chip"
          onClick={() =>
            update((d) => (d.crop.rotate90 = (d.crop.rotate90 + 3) % 4))
          }
        >
          ⟲ Rotate left
        </button>
        <button
          className="chip"
          onClick={() =>
            update((d) => (d.crop.rotate90 = (d.crop.rotate90 + 1) % 4))
          }
        >
          ⟳ Rotate right
        </button>
      </div>
      <div className="rowbtns">
        <button
          className={`chip ${state.crop.flipH ? 'is-active' : ''}`}
          onClick={() => update((d) => (d.crop.flipH = !d.crop.flipH))}
        >
          Flip H
        </button>
        <button
          className={`chip ${state.crop.flipV ? 'is-active' : ''}`}
          onClick={() => update((d) => (d.crop.flipV = !d.crop.flipV))}
        >
          Flip V
        </button>
      </div>

      <p className="hint">Crop rectangle</p>
      <Slider
        label="Left"
        value={state.crop.x}
        min={0}
        max={0.9}
        step={0.01}
        onChange={(v) =>
          update((d) => {
            d.crop.x = v;
            d.crop.width = Math.min(d.crop.width, 1 - v);
          })
        }
      />
      <Slider
        label="Top"
        value={state.crop.y}
        min={0}
        max={0.9}
        step={0.01}
        onChange={(v) =>
          update((d) => {
            d.crop.y = v;
            d.crop.height = Math.min(d.crop.height, 1 - v);
          })
        }
      />
      <Slider
        label="Width"
        value={state.crop.width}
        min={0.1}
        max={1}
        step={0.01}
        defaultValue={1}
        onChange={(v) =>
          update((d) => (d.crop.width = Math.min(v, 1 - d.crop.x)))
        }
      />
      <Slider
        label="Height"
        value={state.crop.height}
        min={0.1}
        max={1}
        step={0.01}
        defaultValue={1}
        onChange={(v) =>
          update((d) => (d.crop.height = Math.min(v, 1 - d.crop.y)))
        }
      />
      <button
        className="chip"
        onClick={() =>
          set('crop', {
            ...state.crop,
            x: 0,
            y: 0,
            width: 1,
            height: 1,
          })
        }
      >
        Reset crop
      </button>
    </>
  );
}
